
import Vue from 'vue'
import Button from "@/components/button.vue";

export default Vue.extend({
  name: 'pd-dtcblock',
  components: {
    "pd-button": Button
  },
  methods: {
    add() {
      this.clickFn(this.dataId)
    },
    setFile(e:any) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      const file = e.target.files[0];
      let reader = new FileReader()
      reader.readAsDataURL(file);
      reader.onload = ()=> {
        if(reader.result) {
          const rowIdx = e.target.getAttribute("a-pd-idx");
          this.$props.dataObj[rowIdx].file = reader.result.toString();
        }
        else{
          alert("Could not read the file");
        }
      };


    }
  },
  data: () => ({}),
  props: {
    clickFn: Function,
    dataObj: Array,
    dataId: String
  }
})
